var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"question"},[_c('div',{staticClass:"item"},[_vm._v(" 破损包赔服务是指消费者在az好货通购买商品时，若消费者在收货时存在包装/商品破损、漏液的情形，并在签收之时起的72小时发起售后申请，且在消费者提供有效凭证的情况下，az好货通有对破损商品对应金额做退款处理的服务。 ")])])
}]

export { render, staticRenderFns }